import axios from "axios"
import { env } from '../constants'


/* GET HISTORY */
export const history = (token, page = 1) => {
    const uri = `${env.startpoint}history/list?page=${page}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}